"use client"

import { useTranslations } from "next-intl"

import { Chip, Heading } from "@/components/ui"

export interface PdpPerks {
  financingBadge: string | null
  // A secured plan's "Más tiempo" wears the green moretime chip, not the blue interest-free one.
  financingTone?: "nointerest" | "moretime"
  freeShipping: boolean
}

interface PdpHeadProps {
  title: string
  perks?: PdpPerks | null
  className?: string
}

export const PdpHead = ({ title, perks = null, className }: PdpHeadProps) => {
  const t = useTranslations("pdp")
  const hasPerks = Boolean(perks && (perks.financingBadge || perks.freeShipping))
  return (
    <div className={`flex flex-col gap-125 @3xl:gap-250 ${className ?? ""}`}>
      {hasPerks && (
        <div data-testid="pdp-perks" className="flex flex-wrap gap-125">
          {perks?.financingBadge && (
            <Chip tone={perks.financingTone ?? "nointerest"} size="detail">
              {perks.financingBadge}
            </Chip>
          )}
          {perks?.freeShipping && (
            <Chip tone="freeship" size="detail" className="@card:text-caption-lg @3xl:text-body-sm">
              {t("freeShipping")}
            </Chip>
          )}
        </div>
      )}
      <Heading
        as="h1"
        variant="productTitle"
        family="text"
        tone="inherit"
        balance={false}
        title={title}
        className="text-fg-heading @3xl:text-product-title-lg line-clamp-2 text-wrap"
      >
        {title}
      </Heading>
    </div>
  )
}
